import { BookableSlot } from 'src/app/features/bookable-slot/bookable-slot'

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output
} from '@angular/core'
import { Store } from '@ngrx/store'
import { combineLatest, Observable } from 'rxjs'
import { take, map } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { participationSelectors } from 'src/app/features/booking/participation/participation.selectors'
import { Dictionary } from '@ngrx/entity'
import { Product } from 'src/app/features/product/product'
import { productSelectors } from 'src/app/features/product/product.selectors'
import { bookingSelectors } from 'src/app/features/booking/booking.selectors'
import { Booking } from 'src/app/features/booking/booking'
import { ProductService } from 'src/app/features/product/product.service'
import { ParticipationService } from 'src/app/features/booking/participation/participation.service'

@Component({
  selector: 'serie-proposal-item-schedule-cell',
  template: `
    <div
      *ngIf="showTooltip"
      data-tooltip="{{ tooltipText }}"
      class="cell-base"
      (click)="onClick()"
      tabindex="0"
      [ngClass]="{
        'bg-primary': isAvailable && !serieProposalItemId,
        'bg-stripes-svg': isDependantProduct,
        'bg-success': serieProposalItemId && !hasConflictingBooking,
        'bg-danger': serieProposalItemId && hasConflictingBooking,
        'is-start border-left': isStart
      }"
    >
      &nbsp;
    </div>
    <div
      *ngIf="!showTooltip"
      class="cell-base"
      (click)="onClick()"
      tabindex="0"
      [ngClass]="{
        'bg-primary': isAvailable && !serieProposalItemId,
        'bg-stripes-svg': isDependantProduct,
        'bg-success': serieProposalItemId && !hasConflictingBooking,
        'bg-danger': serieProposalItemId && hasConflictingBooking,
        'is-start border-left': isStart
      }"
    >
      &nbsp;
    </div>
  `,
  styleUrls: ['./schedule-cell.component.scss']
})
export class SerieProposalItemScheduleCellComponent
  implements OnInit, OnChanges
{
  @Input() bookableSlots: any[]
  @Input() showTooltip: boolean = false
  @Output() onClickBooking: EventEmitter<BookableSlot> = new EventEmitter()
  @Output() onClickSerieProposalItem: EventEmitter<BookableSlot> =
    new EventEmitter()

  public bookableSlot: BookableSlot
  public isAvailable: boolean = false
  public isStart: boolean = false
  public isEnd: boolean = false
  public isOverbooked: boolean = false
  public isConfirmed: boolean = false
  public isUnconfirmed: boolean = false
  public isFull: boolean = false
  public isDependantProduct: boolean = false
  public serieProposalItemId: number = null
  public hasConflictingBooking: boolean = false
  public productEntities$: Observable<Dictionary<Product>>
  public bookingEntities$: Observable<Dictionary<Booking>>
  public linkedProductDescriptionText: string
  public bookableProductDescriptionText: string
  public tooltipText: string
  constructor(
    private store: Store<AppState>,
    private productService: ProductService,
    public participationService: ParticipationService
  ) {}

  ngOnInit() {
    this.ngOnChanges()
  }

  ngOnChanges() {
    if (!this.bookableSlots || !this.bookableSlots.length) {
      return false
    }

    // for now this feature can only work with 1 booking per space per slot, which is how things are in practive

    this.bookableSlot = this.bookableSlots[0]
    this.isAvailable = this.bookableSlot.isAvailable
    this.isStart = this.bookableSlot['isStart']
    this.isEnd = this.bookableSlot['isEnd']
    this.isDependantProduct = this.bookableSlot['isDependantProduct']
    this.serieProposalItemId = this.bookableSlot['serieProposalItemId']
    this.hasConflictingBooking = this.bookableSlot['hasConflictingBooking']
    this.productEntities$ = this.store.select(productSelectors.selectEntities)
    this.bookingEntities$ = this.store.select(bookingSelectors.selectEntities)

    this.checkStatus$()
      .pipe(take(1))
      .subscribe((isSlotFull) => {
        this.isFull = isSlotFull
      })
  }

  public checkStatus$(): Observable<boolean> {
    return combineLatest([
      this.store.select(participationSelectors.selectAll),
      this.participationService.getParticipantCounts$(this.bookableSlot)
    ]).pipe(
      take(1),
      map(([participations, participantLimits]) => {
        this.linkedProductDescriptionText = `${this.bookableSlot.linkedProductDescription}`
        this.bookableProductDescriptionText = `${this.bookableSlot.bookableProductDescription}`
        this.tooltipText = `${this.bookableSlot.linkedProductId}-${this.bookableSlot.linkedProductDescription} ( ${this.bookableSlot.bookableProductDescription} ) `
        const participants =
          participations.filter(
            (p) => p.bookingId == this.bookableSlot.bookingId
          ) ?? []
        if (participants.length == participantLimits?.maxParticipants) {
          return true
        }
        if (participants?.find((p) => p.isUnconfirmed)) {
          this.isUnconfirmed = true
        }

        if (participants?.length) {
          if (
            participants.length > participantLimits?.maxParticipants ||
            this.bookableSlot.availableParticipantCount < 0
          ) {
            this.isOverbooked = true
          } else if (
            participants.length < participantLimits?.maxParticipants ||
            this.bookableSlot.availableParticipantCount >= 0
          ) {
            this.isConfirmed = true
          }
        } else {
          return false
        }
        return false
      })
    )
  }

  public onClick() {
    if (this.serieProposalItemId) {
      this.onClickSerieProposalItem.emit(this.bookableSlot)
    } else if (this.isAvailable) {
      this.onClickBooking.emit(this.bookableSlot)
    }
  }
}
